import {Action, getModule, Module, Mutation, MutationAction, VuexModule} from "vuex-module-decorators";
import store from "@/store"
import {LadingErrorState} from "@/interfaces/state/ladingerror";
import {IdMapper} from "@/interfaces/state/base";
import {LadingError} from "@/interfaces/entity/ladingerror";
import {LadingErrorParams} from "@/modules/ladingerror/params";
import {PaginationMeta} from "@/interfaces/common";
import {createLadingError, listLadingError, singleLadingError, updateLadingError} from "@/modules/ladingerror/services";

@Module({dynamic: true, name: "ladingError", store})
class LadingErrorModule extends VuexModule implements LadingErrorState {
    data: IdMapper<LadingError> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: LadingErrorParams = new LadingErrorParams;

    get ladingError() {
        return this.ids.map((id: number) => this.data[id]);
    }

    @Mutation
    private UPDATE_LADING_ERROR_PARAMS(payload: any) {
        this.params = payload
    }

    @Mutation
    private UPDATE_LADING_ERROR(payload: LadingError) {
        if(!this.data[payload.id] || !this.ids.includes(payload.id)) return;
        this.data[payload.id] = {...payload}
    }
    @Mutation
    private MAP_LADING_ERROR(payload: any) {
        const idMapper: IdMapper<LadingError> = {};
        this.meta = payload.meta;
        this.ids = payload.datas?.map((ladingError: LadingError) => {
            idMapper[ladingError.id!] = {...ladingError};
            return ladingError.id;
        });
        this.data = idMapper;
    }

    @Mutation
    private ADD_LADING_ERROR(payload: LadingError){
        if (!payload || this.ids.includes(payload.id) || this.data[payload.id]) return;
        this.ids =  [...this.ids, payload.id];
        this.data = {...this.data, [payload.id]: {...payload}}
    }

    @Action({rawError: true})
    public async createLadingError(form: any) {
        const {data} = await createLadingError(form)
        this.ADD_LADING_ERROR(data.data)
    }
    @Action({rawError: true})
    public async listLadingError(params: LadingErrorParams = new LadingErrorParams()) {
        const {data} = await listLadingError(params);
        this.MAP_LADING_ERROR(data);
    }

    @Action({rawError: true})
    public updateLadingErrorParams(payload: any) {
        this.UPDATE_LADING_ERROR_PARAMS(payload);
    }

    @Action({rawError: true})
    public async singleLadingError(id: number) {
        const {data} = await singleLadingError(id);
        return data.data;
    }

    @Action({rawError: true})
    public async updateLadingError(dataReq: any) {
        const {data} = await updateLadingError(dataReq.id, dataReq);
        this.UPDATE_LADING_ERROR(data.data);
    }
}

export const LadingErrorStore = getModule(LadingErrorModule)
